const machineTypes = {
	NONE: 'none',

	// tier 0
	LEMON_POWER: 'lemonpower',
	MACHINING_TABLE: 'machiningtable',
	LOADER: 'loader',

	// tier 1; 20000
	ASSEMBLER: 'assembler',
	WATER_POWER: 'waterpower',
	SMALL_WAREHOUSE: 'smallwarehouse',

	// tier 2; 250000
	CONVEYOR_BELT: 'conveyorbelt',
	STEAM_POWER: 'steampower',
	MEDIUM_WAREHOUSE: 'mediumwarehouse',

	// tier 3; 2500000
	TURBINE_POWER: 'turbinepower',
	TRAIT_PUMP: 'traitpump',
	INDUSTRIAL_WAREHOUSE: 'industrialwarehouse',

	// tier 4; 25 000 000
	ASSEMBLY_LINE: 'assemblyline',
	COAL_POWER:'coalpower',

	// tier 5: 250 000 000
	TRAIT_COMPRESSOR: 'traitcompressor',
	MASSIVE_WHEEL: 'massivewheel'
};

export default machineTypes;